import {IAction} from "../IAction";
import {AcquisitionAction, IAcquisitionSignals} from "./acquisitionReducer";

export function newAcquisitionSignals(signals: IAcquisitionSignals): IAction<AcquisitionAction.NEW_ACQUISITION_SIGNALS, IAcquisitionSignals> {
    return {
        type: AcquisitionAction.NEW_ACQUISITION_SIGNALS,
        payload: signals,
    };
}

export function removeAcquisitionSignals(): IAction<AcquisitionAction.REMOVE_ACQUISITION_SIGNALS, void> {
    return {
        type: AcquisitionAction.REMOVE_ACQUISITION_SIGNALS,
        payload: undefined,
    };
}
